<template>
  <div>
    <b-row>
      <b-col
        cols="9"
        class="mb-1"
      >
        <b-link
          style="font-size: 26px; color: #fff;"
          :to="`/Scada-sub?DeptID=${deptid}`"
        >
          <feather-icon
            style="margin-bottom: 5px;"
            size="34"
            icon="ArrowLeftIcon"
          /> <span style="color: #00FF80;"> SCADA: </span> {{ waydetail }}
        </b-link>
      </b-col>
      <b-col
        cols="3"
        class="text-sm-right d-flex align-items-center justify-content-end"
      >
        <div class="mr-1">
          <b-link
            v-b-modal="'Log'"
            class="nav-link"
            variant="outline-primary"
            @click="$refs.Log.getLogScada()"
          >
            <feather-icon
              icon="FileTextIcon"
              size="24"
              style="color:aqua"
            />
            <span style="color:#ffffff"> Log</span>
          </b-link>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="12">
        <b-card
          class="hero4"
          style="font-size:18px; width:auto; height:auto; background-color:rgba(0, 0, 0, 0.6); color:#ffffff; border: 1px solid #00B058; border-radius: 20px;"
        >
          <b-row>
            <b-col
              cols="8"
            >
              <h3>Diagram</h3>
            </b-col>
            <b-col
              lg="12"
              md="12"
              sm="12"
            >
              <diagram />
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <modalLog
      ref="Log"
    />
  </div>
</template>

<script>
import {
  BRow, BCol, BCard, BLink,
} from 'bootstrap-vue'
import 'leaflet/dist/leaflet.css'
import axios from '@axios'
import diagram from './diagram/drr-diagram.vue'
import modalLog from './modalLog.vue'

export default {
  components: {
    BCol,
    BRow,
    BCard,
    BLink,
    diagram,
    modalLog,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem('userData')),
      center: [],
      waydetail: '',
      deptid: '',
      type_name: '',
    }
  },
  computed: {
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  created() {
    this.$store.commit('verticalMenu/UPDATE_VERTICAL_MENU_COLLAPSED', true)
  },
  mounted() {
    this.getCenter()
  },
  methods: {
    getCenter() {
      axios
        .post('/waySEMControlDetail', { wid: this.$route.query.wid })
        .then(response => {
          this.center = []
          this.waydetail = response.data[0].detail
          this.deptid = response.data[0].deptid
          this.type_name = response.data[0].type_name
        })
        .catch(error => {
          console.log(error)
        })
    },
  },
}
</script>

<style  lang="scss" scoped>
</style>
